const l = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle cx="16" cy="16" r="16" />
        <path
            d="M23.111 20.622c0 .638-.517 1.156-1.156 1.156h-11.91a1.156 1.156 0 01-1.156-1.156V13.29l6.828 3.402.233.115.235-.11 6.926-3.204v7.129zm0-8.458l-7.146 3.371-7.076-3.593v-.12c0-.638.517-1.155 1.156-1.155h11.91c.639 0 1.156.517 1.156 1.156v.34z"
            fill="currentColor" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=email.es.BFkfB32Y.js.map
